// Language utilities for getting current language across the application
import i18n from '../i18n';

/**
 * Get the current language from various possible sources
 * Handles different Vue i18n versions and configurations
 */
export function getCurrentLanguage() {
  let currentLanguage = 'ml'; // fallback
  
  try {
    // Try Vue 3 composition API approach first
    if (i18n && i18n.global && i18n.global.locale) {
      if (typeof i18n.global.locale === 'string') {
        currentLanguage = i18n.global.locale;
      } else if (i18n.global.locale.value) {
        currentLanguage = i18n.global.locale.value;
      }
    }
    // Try direct access to mode
    else if (i18n && i18n.mode === 'composition' && i18n.global) {
      currentLanguage = i18n.global.locale.value || 'ml';
    }
    // Try legacy mode
    else if (i18n && i18n.locale) {
      currentLanguage = i18n.locale;
    }
    // Try accessing from global Vue instance if available
    else if (window.Vue && window.Vue.config && window.Vue.config.globalProperties) {
      const globalI18n = window.Vue.config.globalProperties.$i18n;
      if (globalI18n && globalI18n.locale) {
        currentLanguage = globalI18n.locale;
      }
    }
  } catch (error) {
    console.warn('Error getting current language, using fallback:', error);
  }
  
  return currentLanguage;
}

/**
 * Set the current language across all i18n instances
 */
export function setCurrentLanguage(language) {
  try {
    // Set in global i18n instance
    if (i18n && i18n.global && i18n.global.locale) {
      if (typeof i18n.global.locale === 'string') {
        i18n.global.locale = language;
      } else if (i18n.global.locale.value !== undefined) {
        i18n.global.locale.value = language;
      }
    }
    
    // Set in legacy mode
    if (i18n && i18n.locale !== undefined) {
      i18n.locale = language;
    }
    
    return true;
  } catch (error) {
    console.warn('Error setting language:', error);
    return false;
  }
}

/**
 * Debug function to inspect i18n instance state
 */
export function debugI18nInstance() {
  try {
    console.log('=== i18n Debug Info ===');
    console.log('i18n object:', i18n);
    
    if (i18n) {
      console.log('i18n.mode:', i18n.mode);
      console.log('i18n.locale:', i18n.locale);
      
      if (i18n.global) {
        console.log('i18n.global:', i18n.global);
        console.log('i18n.global.locale:', i18n.global.locale);
        
        if (i18n.global.locale && i18n.global.locale.value) {
          console.log('i18n.global.locale.value:', i18n.global.locale.value);
        }
      }
      
      console.log('Current language detected:', getCurrentLanguage());
    } else {
      console.log('i18n instance not found');
    }
    
    console.log('======================');
  } catch (error) {
    console.error('Error in debugI18nInstance:', error);
  }
}

export default {
  getCurrentLanguage,
  setCurrentLanguage,
  debugI18nInstance
};